'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement('i', { className: 'ion-ios-contact' });

var _ref2 = _react2.default.createElement('i', { className: 'ion-ios-locked-outline' });

var _ref3 = _react2.default.createElement(
	'div',
	{ className: 'col-xs-12 text-center small-text' },
	'Not a member yet? ',
	_react2.default.createElement(
		'a',
		{ href: '/signup' },
		'Sign Up'
	)
);

var _ref4 = _react2.default.createElement(
	'a',
	{ href: '/forgot-password', className: 'text-center' },
	'Forgot your password?'
);

var LoginComponent = function LoginComponent(props) {
	var validateEmail = function validateEmail(email) {
		var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	};
	return _react2.default.createElement(
		'div',
		{ className: _style2.default.loginComponent },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.body },
			_react2.default.createElement(
				'form',
				{ className: 'form-horizontal' },
				_react2.default.createElement(
					'div',
					{ className: 'form-group' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'div',
							{ className: 'df-input-group' },
							_ref,
							_react2.default.createElement('input', {
								id: 'emailInput',
								className: 'form-control ' + ((props.error || props.submitAttempted && !props.validEmail) && _style2.default.inputError),
								onChange: function onChange(event) {
									props.updateEmail(event.target.value);
								},
								onBlur: function onBlur() {
									props.setValidEmail(validateEmail(props.email));
								},
								onKeyDown: function onKeyDown(event) {
									if (event.keyCode === 13) {
										if (props.validEmail) {
											props.login({
												password: document.getElementById('passwordInput').value,
												name: props.email,
												rememberMe: props.rememberMe
											});
											return;
										}
										props.validationError();
										event.preventDefault();
									}
								},
								type: 'email',
								placeholder: 'Email Address'
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: props.submitAttempted && !props.validEmail ? _style2.default.errorMessageShow : _style2.default.errorMessageHide },
						'Please enter a valid email address'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'form-group' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'div',
							{ className: 'df-input-group' },
							_ref2,
							_react2.default.createElement('input', {
								id: 'passwordInput',
								type: 'password',
								className: 'form-control ' + (props.error && _style2.default.inputError),
								placeholder: 'Password',
								onKeyDown: function onKeyDown(event) {
									if (event.keyCode === 13) {
										if (props.validEmail) {
											props.login({
												password: document.getElementById('passwordInput').value,
												name: props.email,
												rememberMe: props.rememberMe
											});
											return;
										}
										props.validationError();
										event.preventDefault();
									}
								}
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (props.error && _style2.default.error) + ' ' + (props.error ? _style2.default.errorMessageShow : _style2.default.errorMessageHide) + ' text-center' },
						_react2.default.createElement(
							'span',
							null,
							props.error && props.errorMessage
						)
					)
				),
				!props.disableLinks && _react2.default.createElement(
					'div',
					{ className: _style2.default.extras },
					_react2.default.createElement(
						'div',
						{ className: 'text-center' },
						_react2.default.createElement('input', {
							onClick: function onClick() {
								props.rememberMeChecked(props.rememberMe);
							},
							type: 'checkbox',
							id: _style2.default.rememberMeCheckbox
						}),
						_react2.default.createElement(
							'label',
							{ htmlFor: _style2.default.rememberMeCheckbox },
							'Remember Me'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: (props.disableLinks && _style2.default.disableLinksButton) + ' form-group' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 text-center' },
						_react2.default.createElement(
							'button',
							{ className: 'btn solid large wide',
								type: 'button',
								onClick: function onClick(event) {
									props.login({
										password: document.getElementById('passwordInput').value,
										name: props.email,
										rememberMe: props.rememberMe
									});
									event.preventDefault();
								} },
							props.alternateButtonText || 'Log in'
						)
					),
					!props.disableLinks && _ref3,
					!props.disableLinks && _ref4
				)
			)
		)
	);
};

LoginComponent.propTypes = {
	validEmail: require('react').PropTypes.any.isRequired,
	submitAttempted: require('react').PropTypes.any.isRequired,
	submitFailed: require('react').PropTypes.any.isRequired,
	error: require('react').PropTypes.any.isRequired,
	email: require('react').PropTypes.any,
	rememberMe: require('react').PropTypes.any.isRequired,
	disableLinks: require('react').PropTypes.any,
	alternateButtonText: require('react').PropTypes.any,
	errorMessage: require('react').PropTypes.any,
	rememberMeChecked: require('react').PropTypes.func.isRequired,
	updateEmail: require('react').PropTypes.func.isRequired,
	setValidEmail: require('react').PropTypes.func.isRequired,
	login: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired
};
LoginComponent.displayName = 'LoginComponent';

LoginComponent.defaultProps = {};

exports.default = LoginComponent;